import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { Auth, signInWithCustomToken } from '@angular/fire/auth';
import { firstValueFrom } from 'rxjs';
import { LogoutService } from 'src/app/modules/auth/components/auth/auth.service';

@Injectable({
	providedIn: 'root'
})
export class ImpersonationService {
	constructor(
		private fns: AngularFireFunctions,
		private auth: Auth,
		private logoutService: LogoutService
	) {}

	async startImpersonation(targetUserId: string) {
		const startImpersonationCallable = this.fns.httpsCallable('user-startImpersonation');
		const resp: any = await firstValueFrom(startImpersonationCallable({ targetUserId }));

		const token = resp?.token;
		const sessionId = resp?.sessionId;
		const targetUser = resp?.targetUser;

		if (!token || !sessionId || !targetUser) {
			throw new Error('Invalid impersonation response.');
		}

		const impersonatorMeta = {
			id: localStorage.getItem('userId') || "",
			email: localStorage.getItem('username') || "",
			name: localStorage.getItem('firstName') || "",
			roleId: localStorage.getItem('roleId') || "",
			orgId: localStorage.getItem('orgId') || ""
		};

		await signInWithCustomToken(this.auth, token);
		this.logoutService.setUserSession(targetUser);

		localStorage.setItem('isImpersonating', 'true');
		localStorage.setItem('impersonationSessionId', sessionId);
		localStorage.setItem('impersonatorMeta', JSON.stringify(impersonatorMeta));
	}

	async stopImpersonation() {
		const sessionId = localStorage.getItem('impersonationSessionId');
		if (!sessionId) {
			throw new Error('Missing impersonation session.');
		}

		const stopImpersonationCallable = this.fns.httpsCallable('user-stopImpersonation');
		const resp: any = await firstValueFrom(stopImpersonationCallable({ sessionId }));

		const token = resp?.token;
		const adminUser = resp?.adminUser;

		if (!token || !adminUser) {
			throw new Error('Invalid stop impersonation response.');
		}

		await signInWithCustomToken(this.auth, token);
		this.logoutService.setUserSession(adminUser);
		this.clearImpersonationState();
	}

	isImpersonating() {
		return localStorage.getItem('isImpersonating') === 'true';
	}

	getImpersonationSessionId() {
		return localStorage.getItem('impersonationSessionId') || "";
	}

	clearImpersonationState() {
		localStorage.removeItem('isImpersonating');
		localStorage.removeItem('impersonationSessionId');
		localStorage.removeItem('impersonatorMeta');
	}
}
